import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import historicsFields from '../../../fields/historicsFields';

export const columnsPosTerminalsHistoricsId = 'posTerminalsHistorics';

export const columnsPosTerminalsHistorics = (headerPackage) => {
    return ([
        // ColumnSelection
        generateColumnDefByField({
            field: historicsFields.POS_TERMINALS_HISTORICS.SERIAL_NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: historicsFields.POS_TERMINALS_HISTORICS.MANUFACTURER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: historicsFields.POS_TERMINALS_HISTORICS.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: historicsFields.POS_TERMINALS_HISTORICS.CUSTOM_LABEL,
            headerPackage: headerPackage,
            isLongText: true
        })
    ]).filter(col => !!col);
};